export const getReimbursementReportValues = (
  data?: { data?: { final_note?: string | null } } | null,
) => ({
  final_note: data?.data?.final_note ?? "",
});
